// extracted by mini-css-extract-plugin
export default {"alertsZone":"Alert_alertsZone__UU57Q","showed":"Alert_showed__AQq6N"};